import type { MosObjCompatibleItem } from '@mimir/common/mos/mos-interfaces';
import { mdfState } from '@mimir/web/globals/mdfState';
import { SystemDefaultField } from '@mimir/common/mdf/mdfDefaults';
import { getItemSystemDefaultField, replaceIdWithFieldIdForSchemasAndFillDefaultValues } from '@mimir/common/mdf/MetaDataForm';
import type { SearchResultHit, LoadedItem } from '@mimir/common/dto/searchResultHit';
import { assert } from '@mimir/common/util/invariant';
import { getFieldDefinitionsForMetadata } from '@mimir/common/mdf/subtype';

export function createMosCompatibleItem(item: (SearchResultHit | LoadedItem)): MosObjCompatibleItem {
  const allSchemas = mdfState.state.mdfs;
  const { fieldMap } = getFieldDefinitionsForMetadata(item.metadata, allSchemas);

  let created: Date | undefined;
  if (item.metadata.formData[SystemDefaultField.CreatedOn]) {
    created = new Date(item.metadata.formData[SystemDefaultField.CreatedOn] as  string);
  }
  let changed: Date | undefined;
  if (item.modifiedOn) {
    changed = new Date(item.modifiedOn);
  }

  const itemType = item.itemType;
  assert(itemType !== 'folder', 'Did not expect folder');

  return {
    ...item,
    itemType,
    title: getItemSystemDefaultField(item, SystemDefaultField.Title),
    description: getItemSystemDefaultField(item, SystemDefaultField.Description),
    exportFriendlyMetadata: replaceIdWithFieldIdForSchemasAndFillDefaultValues(item.metadata, Object.values(fieldMap)),
    hasHighres: (item as LoadedItem).highRes !== undefined,
    created,
    changed,
  };
}
